import canvases from "@/generated/scheme-canvas.json"

export const COLOR_SCHEMES = ["light", "dark"] as const

export type ColorScheme = (typeof COLOR_SCHEMES)[number]

export const DEFAULT_SCHEME: ColorScheme = "light"

export const SCHEME_ATTRIBUTE = "data-scheme"
export const SCHEME_HEADER = "x-nelo-app-scheme"
export const SCHEME_COOKIE = "nelo_scheme"
export const SCHEME_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export const SCHEME_CANVAS: Readonly<Record<ColorScheme, string>> = canvases

export const parseScheme = (value: unknown): ColorScheme | undefined => COLOR_SCHEMES.find((scheme) => scheme === value)

export const readColorScheme = (data: Record<string, unknown>): ColorScheme | undefined => parseScheme(data.colorScheme)
